module.exports = __webpack_public_path__ + "assets/img/img32.d1ef61d2.png";